export class MenuGroupLabels {
  static readonly INFO = 'PLB INFORMATION';
  static readonly TASKS = 'PLB TASKS';
  static readonly ADMIN_TASKS = 'PLB TASKS';
}
